import React from "react";
import ReactDOM from "react-dom";
import packageJson from "../package.json";
import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import ScrollToTop from "./components/scroll-to-top/scroll-to-top.component";
import * as serviceWorker from "./serviceWorker";
import store from "./redux/store";

import "./i18n/i18n";
import "./index.css";
import App from "./App";

console.log(`v${packageJson.version}`);

ReactDOM.render(
  <HelmetProvider>
    <Provider store={store}>
      <BrowserRouter>
        <ScrollToTop />
        <App />
      </BrowserRouter>
    </Provider>
  </HelmetProvider>,
  document.getElementById("root"),
);

serviceWorker.unregister();
